'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ensure_deeplink = ensure_deeplink;
function ensure_deeplink(url) {
  var ifr = document.createElement('iframe');
  ifr.src = url;
  ifr.style.display = 'none';
  document.body.appendChild(ifr);
  // let openTime = Date.now();
  setTimeout(function () {
    document.body.removeChild(ifr);
  }, 1000);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@beastshop/iframe-deeplink/lib/index.js
// module id = 1051
// module chunks = 0